import { Google, Yandex } from '@shared/assets/icons/components';
import { Routes } from '@shared/constants/routes';
import { Button, Flex } from 'antd';
import styles from './oauth.module.scss';
import { useTranslation } from 'react-i18next';

export const Oauth = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'auth.signIn' });
  const handleYandexAuth = () => {
    const redirectUri = `${window.location.origin}${Routes.authentication.oauthYandex}`;
    const authUrl = `https://oauth.yandex.ru/authorize?response_type=token&client_id=727b96c6820b4974a4268256f408dd12&redirect_uri=${encodeURIComponent(redirectUri)}`;

    window.location.href = authUrl;
  };

  const handleGoogleAuth = () => {
    const redirectUri = `${window.location.origin}${Routes.authentication.oauthGoogle}`;
    const clientId = '338430249981-okhchbckohicvrtrnac85m71v8el44c0.apps.googleusercontent.com';
    const scope = 'openid email profile';

    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: 'token',
      scope,
      prompt: 'consent',
    });

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?${params}`;
    window.location.href = authUrl;
  };

  return (
    <Flex vertical gap={12} className={styles.simpleList}>
      <Button
        onClick={handleYandexAuth}
        icon={<Yandex />}
        className={styles.simpleButton}
        block
      >
        {t('yandex')}
      </Button>

      <Button
        onClick={handleGoogleAuth}
        icon={<Google />}
        className={styles.simpleButton}
        block
      >
        {t('google')}
      </Button>
    </Flex>
  );
};
